import React, {Component, PropTypes} from "react";
import {inject, observer} from "mobx-react";
import * as mobx from "mobx";
import objectAssign from "object-assign";
import {Button, Modal, Spin} from "antd";
import {WeaTools, WeaDialog, WeaSelect, WeaInput, WeaSearchGroup, WeaFormItem,WeaLocaleProvider} from "ecCom";
import {WeaSwitch} from 'comsMobx';

const comTypes = WeaTools.types;
const getLabel = WeaLocaleProvider.getLabel
const formItemLayout = {
    labelCol: {span: 6},
    fieldcol: {span: 18},
};

@observer
export default class EditSysFavourite extends Component {
    /**
     * 关闭窗口
     */
    closeEditFormWin = () => {
        let {favouriteDialogStore, sysFavFormStore} = this.props;
        favouriteDialogStore.closeEditDialog();
        sysFavFormStore.resetForm();
    }

    onChange(data) {
        let {sysFavFormStore} = this.props;
        sysFavFormStore.saveFormFields(data);
    }

    /**
     * 获取表单的数据
     * @returns {Array}
     */
    getFormData = () => {
        let {sysFavFormStore} = this.props;
        let {pagename, favouritetype, favouriteObjid, favtypename, typelist} = sysFavFormStore;

        let items = [];
        items.push({
            colSpan: 1,
            conditionType: comTypes.INPUT,
            domkey: ["pagename"],
            isQuickSearch: false,
            label: getLabel(22426, '收藏标题'),
            value: pagename,
            viewAttr: 3,
            length: 3000,
            ...formItemLayout
        });


        favouriteObjid = Number(favouriteObjid);
        let viewAttr = 2;
        if (favouriteObjid > 0 || Object.is(favouritetype, "6")) {      //收藏的对象存在，或者消息类型，不可编辑
            viewAttr = 1;
        }
        typelist = mobx.toJS(typelist);
        let options = [];
        typelist.forEach(item => {
            let {id, name} = item;
            options.push({
                key: id,
                showname: name,
                selected: false
            });
        });

        items.push({
            colSpan: 1,
            conditionType: comTypes.SELECT,
            domkey: ["favouritetype"],
            isQuickSearch: false,
            label: getLabel(22242, '收藏类型'),
            options,
            value: favouritetype,
            viewAttr,
            ...formItemLayout
        });
        return items;
    }

    getFormItems() {
        let {sysFavFormStore} = this.props;
        let datas = this.getFormData();
        const {form} = sysFavFormStore;
        const {isFormInit} = form;
        let items = [];
        isFormInit && datas.forEach(field => {
            items.push({
                com: (
                    <WeaFormItem
                        label={`${field.label}`}
                        labelCol={field.labelCol}
                        wrapperCol={field.fieldcol}>
                        <WeaSwitch fieldConfig={field} form={form} onChange={this.onChange.bind(this)}/>
                    </WeaFormItem>
                )
            });
        });

        let groups = [];

        groups.push(<WeaSearchGroup needTigger={false} title={getLabel(81711, '基本信息')} showGroup={true} items={items} col={1}/>);

        return groups;
    }

    handleSubmit = (evt) => {
        evt.preventDefault();
        let {sysFavFormStore} = this.props;
        sysFavFormStore.saveForm();
    }

    componentDidUpdate() {
        let {sysFavFormStore} = this.props;
        let datas = this.getFormData();
        const {form} = sysFavFormStore;
        let conditions = [{items: datas}];
        form.initFormFields(conditions);
    }

    render() {
        let formItems = this.getFormItems();
        let {favouriteDialogStore, sysFavFormStore} = this.props;
        let visible = favouriteDialogStore.showEditDialog;
        let title = `${getLabel(388213, '编辑收藏')}`;
        let style = {width: 460, height: 200};
        let buttons = [
            (<Button onClick={this.handleSubmit}>{getLabel('826','确定')}</Button>),
            (<Button onClick={this.closeEditFormWin}>{getLabel('31129','取消')}</Button>)
        ];

        let onCancel = this.closeEditFormWin;

        let params = {visible, title, style, buttons, onCancel};

        let {spinning, tip} = sysFavFormStore;

        return (
            <WeaDialog {...params}>
                <Spin spinning={spinning} tip={tip} size="large" style={{"height": "100%"}}>
                    <div className="sysfav-form-container">
                        {formItems}
                    </div>
                </Spin>
            </WeaDialog>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/EditSysFavourite.js